import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className='page-content'>

       
        <div className="container">
            <div className="row content-layout-wrapper align-items-start">
                <div className="elementor elementor-3">
                    <div
                        className="wd-negative-gap elementor-element elementor-element-15a9279 e-flex e-con-boxed e-con e-parent"
                        data-id="15a9279"
                        data-element-type="container"
                        data-settings='{"content_width":"boxed"}'
                        data-core-v316-plus="true"
                    >
                        <div className="e-con-inner">
                            <div
                                className="elementor-element elementor-element-43034055 color-scheme-inherit text-left elementor-widget elementor-widget-text-editor"
                                data-id="43034055"
                                data-element-type="widget"
                                data-widget-type="text-editor.default"
                            >
                                <div className="elementor-widget-container">
                                    {/* <h2><strong>Wwings Smart Technologies Pvt. Ltd.</strong></h2> */}
                                    <h3><strong>Privacy Policy</strong></h3>

                                    <p><strong>1. Introduction</strong></p>
                                    <p>
                                        At Wwings Smart Technologies Pvt. Ltd., we respect your privacy and are committed to protecting your personal data.
                                        This privacy policy will inform you how we handle and protect your personal data when you visit our website and tell you about your privacy rights and how the law protects you.
                                    </p>

                                    <p><strong>2. The Data We Collect About You</strong></p>
                                    <p>
                                        Personal data, or personal information, means any information about an individual from which that person can be identified.
                                        We may collect, use, store, and transfer different kinds of personal data about you which we have grouped together as follows:
                                    </p>
                                    <ul>
                                        <li>Identity Data</li>
                                        <li>Contact Data</li>
                                        <li>Technical Data</li>
                                        <li>Usage Data</li>
                                    </ul>

                                    <p><strong>3. How We Use Your Personal Data</strong></p>
                                    <p>
                                        We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
                                    </p>
                                    <ul>
                                        <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
                                        <li>Where it is necessary for our legitimate interests and your interests and fundamental rights do not override those interests.</li>
                                        <li>Where we need to comply with a legal or regulatory obligation.</li>
                                    </ul>

                                    <p><strong>4. Data Security</strong></p>
                                    <p>
                                        We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed.
                                    </p>

                                    <p><strong>5. Third-Party Links</strong></p>
                                    <p>
                                        Our website may include links to third-party websites, plug-ins, and applications.
                                        Clicking on those links or enabling those connections may allow third parties to collect or share data about you.
                                        We do not control these third-party websites and are not responsible for their privacy statements.
                                    </p>

                                    <p><strong>6. Your Legal Rights</strong></p>
                                    <p>
                                        Under certain circumstances, you have rights under data protection laws in relation to your personal data including the right to receive a copy of the personal data we hold about you and the right to make a complaint at any time to the Data Protection Commissioner’s Office, the supervisory authority for data protection issues.
                                    </p>

                                    <p><strong>7. Changes to the Privacy Policy and Your Duty to Inform Us of Changes</strong></p>
                                    <p>
                                        This version was last updated on 19 Oct 2023 and historic versions can be obtained by contacting us.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
};

export default PrivacyPolicy;
